module.exports = __webpack_public_path__ + "img/bg4.c4590015.jpg";